import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';

import 'rxjs/add/operator/mergeMap';
import {ACLFeature} from '../../_models/acl-feature';
import {SensorAccessory} from '../../_models/sensor_accessory';

const log = Log.create('BatchEditSensorsAccessories');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class BatchEditSensorAccessoriesComponent implements OnInit {
  // family: ModuleFamily = new ModuleFamily('test');
  parentId: number;
  path: string;
  sensorAccessoryIds: any;
  sensorAccessories: any;
  sensorApplications: Array<any> = [];

  iCanMaintenanceMode: boolean = false;

  description?: string = null;
  sensorAccessoryType?: any;

  toggleDescription: boolean = false;
  toggleAccessoryType: boolean = false;
  toggleSensorApplications: boolean = false;

  possibleSensorApplications: any;
  possibleSensorAccessoryType: any;
  allSensorAccessoryTypes: any;

  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {

    log.d('ngOnInit');
    // this.path = (this.route.snapshot.parent.params['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';
    //
    this.route.params.subscribe((params: any) => {
      log.d(`route /${this.route.snapshot.parent.params['type']}/${params['id']}`, );
      this.sensorAccessoryIds = params.list.split(',').map( param => parseInt(param) ); // moet een array met getallen worden.
      log.d('sensorAccessories recieved from params', this.sensorAccessoryIds);


      this.admin.getSensorAccessoryControllers(this.sensorAccessoryIds).subscribe((data) => {
        log.d('getSensorAccessoryControllers response', data);
        this.sensorAccessories = data.data;

        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleSensorApplications = res.data;
        });

        this.admin.getSensorAccessoryTypes().subscribe((res) => {
          this.allSensorAccessoryTypes = res.data;
          this.possibleSensorAccessoryType = res.data.map(type => {
            return {text: type.name, id: type.id };
          });
        });
      });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this[input.model] = input.updatedData;
  }

  public onSubmit() {
    log.d('updated sensorAccessories', this.sensorAccessories);
    for (const sensorAccessory of this.sensorAccessories) {
      if (this.toggleDescription) {
        sensorAccessory.description = this.description;
      }
      if (this.toggleSensorApplications) {
        sensorAccessory.sensorApplications = this.sensorApplications;
      }
      if (this.toggleAccessoryType) {
        sensorAccessory.type = this.sensorAccessoryType;
      }
    }
    this.admin.postSensorAccessoryControllers(this.sensorAccessories).subscribe(data => {
      this.toast.success(`Changes have been saved.`);
      this.router.navigate(['/drilldown/sensor-accessories', {refresh: Date.now()}]);
    });
  }

  public onCancel() {
    log.d('onCancel');
    this.router.navigate(['/drilldown//sensor-accessories', {refresh: Date.now()}]);
  }

  public preselectedDropdownValue() {
    if (!this.sensorAccessoryType) {
      return [];
    } else {
      return [{text: this.sensorAccessoryType[0].name, id: this.sensorAccessoryType[0].id }];
    }
  }

  public selectedAccessoryType(value) {
    const selectedType = this.allSensorAccessoryTypes.find(x => x.id === value.id);
    this.sensorAccessoryType = [selectedType];
  }

}



// WEBPACK FOOTER //
// ./src/app/batch/sensor-accessories/edit.component.ts